export const dataCareers = [
    {
    jobTitle: "MID Motion Graphics Artist *",
    dept: "GFX",
    workMode: "Expression of Interest",
    aboutRole: " We’re looking for a Mid Motion Graphics Artist to join our creative team and help design and execute motion graphics across a variety of commercial, branded, and entertainment projects.",

    whatYoullDo: [
        "Design and animate high-quality 2D and 3D motion graphics for commercial, branded, and entertainment projects",
        "Work closely with creative directors, supervisors, and producers to develop concepts and visual directions",
        "Create styleframes, animation tests, transitions, titles, and graphic packages",
        "Take projects from initial concept through animation, revisions, and final delivery",
        "Manage multiple projects and deadlines while maintaining a high level of visual quality",
        "Collaborate with VFX artists and other departments when projects combine motion graphics and visual effects"
    ],

    whatYoullNeed: [
        "Minimum 3-4 years of professional motion graphics experience",
        "Strong proficiency in Adobe After Effects",
        "Strong understanding of animation principles, typography, composition, and design",
        "Experience with Adobe Photoshop and Illustrator",
        "Experience working within production deadlines and responding to creative feedback",
        "A strong portfolio or reel demonstrating motion design and animation work",
        "Experience with Blender, Cinema 4D, or other 3D software is considered an asset"
    ],

    salary: "28-$38/hour"
    },
    {
    jobTitle: "Generalist",
    dept: "VFX",
    workMode: "In Person - Contract",
    aboutRole: "We’re looking for a versatile Generalist who is comfortable working across multiple areas of visual effects and content creation. This role is ideal for an artist who enjoys solving different creative challenges and working across both 2D and 3D workflows.",

    whatYoullDo: [
        "Work across a variety of VFX tasks depending on project requirements",
        "Assist with look development, lighting, rendering, and basic 3D asset work ",
        "Handle 3D tracking/matchmove",
        "Ability to do basic compositing, cleanup, tracking, keying, roto, and other general VFX work",
        "Take ownership of assigned shots from initial setup through final delivery",
    ],

    whatYoullNeed: [
        "Minimum 2-3 years of professional experience in 3D ranging from modeling/texturing/animation",
        "Experience with Blender/Syntheyes or another 3D and tracking  packages",
        "Working knowledge of Foundry's Nuke and AE is an asset",
        "Ability to adapt quickly between different types of creative and technical tasks",
        "A portfolio or reel demonstrating a range of visual effects and generalist work"
    ],

    salary: "31-$41/hour"
    },
    {
    jobTitle: "Technical Director*",
    dept: "Engineering",
    workMode: "Expression of Interest",
    aboutRole: "We’re looking for a Generalist Technical Director to help bridge the gap between artists, production, and technology. This role focuses on building tools, improving workflows, troubleshooting technical issues, and helping our artists work more efficiently across Nuke, After Effects, Blender, and our broader studio pipeline.",

    whatYoullDo: [
        "Develop and maintain tools that improve artist workflows across Nuke, After Effects, and Blender",
        "Build scripts, utilities, and pipeline tools to automate repetitive production tasks",
        "Support artists with technical troubleshooting and workflow issues",
        "Work with supervisors and artists to identify pipeline bottlenecks and develop practical solutions",
        "Integrate production tools with file systems, project tracking systems, and other studio infrastructure",
        "Maintain and improve existing studio tools and workflows",
        "Document tools and workflows so they can be easily used across the studio",
        "Prototype new technical solutions and help evaluate emerging tools and technologies"
    ],

    whatYoullNeed: [
        "Minimum 2 years of professional experience in a technical or pipeline role within VFX, animation, motion graphics, or post-production",
        "Professional experience with Nuke, Adobe After Effects, and Blender",
        "Strong Python scripting skills",
        "Experience working with APIs, automation, or pipeline tools",
        "Understanding of VFX production workflows, file structures, image sequences, colour pipelines, and render processes",
        "Ability to troubleshoot technical problems across software, scripts, and production environments",
        "Comfort working directly with artists and translating production problems into technical solutions",
        "Experience with JavaScript, ExtendScript, Git, ShotGrid, or similar tools is considered an asset"
    ],

    salary: "32-$46/hour"
    },
    {
    jobTitle: "Executive Producer",
    dept: "Production",
    workMode: "Hybrid - Contract",
    aboutRole: "We’re looking for an experienced Executive Producer to lead client relationships, drive new business, and oversee the successful delivery of projects across VFX, motion graphics, and creative production. This role sits at the intersection of business development and production helping grow the studio.",

    whatYoullDo: [
        "Build and maintain strong relationships with clients, agencies, production companies, and creative partners",
        "Lead new business opportunities from initial conversations through bidding, award, and project kickoff",
        "Work closely with producers and supervisors to establish project scope, budgets, schedules, and resourcing",
        "Oversee multiple projects at a high level and ensure client expectations, creative goals, and commercial targets are aligned",
        "Review and approve bids, estimates, change orders, and major production decisions",
        "Identify opportunities to grow existing client relationships and develop new areas of business",
        "Represent the studio in client meetings, pitches, industry events, and external partnerships",
        "Support and mentor producers while helping improve production processes and project management practices",
        "Collaborate with company leadership on studio strategy, capacity planning, pricing, and business development"
    ],

    whatYoullNeed: [
        "Minimum 7+ years of professional experience in VFX, post-production, advertising, or a related creative production environment",
        "Previous experience as a Senior Producer, VFX Producer, Executive Producer, or similar production leadership role",
        "Strong existing understanding of post-production workflows",
        "Demonstrated experience managing client relationships, budgets, schedules, and multidisciplinary creative teams",
        "Experience developing new business, preparing bids, and converting opportunities into awarded projects",
        "Excellent communication, negotiation, and relationship-building skills",
        "Strong commercial awareness with the ability to balance creative ambition, production realities, and project profitability",
        "Ability to manage multiple high-level priorities while remaining involved where projects or clients require additional support",
        "Existing relationships within advertising, production, VFX, or creative industries are considered a strong asset"
    ],

    salary: "40-$80/hour"
    },
]